import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

const RadialBarMultiple = ({ series, labels, colors, total }) => {
    const { t } = useTranslation('common');
    const options = {
        chart: {
          height: 350,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            track: {
              show: false,
            },
            dataLabels: {
              name: {
                fontSize: '20px',
                fontWeight: 600,
                offsetY: -12,
              },
              value: {
                fontSize: '24px',
                fontWeight: 700,
                offsetY: 12,
              },
              total: {
                show: true,
                label: t('charts.total'),
                fontSize: '20px',
                fontWeight: 600,
                formatter: function (w) {
                  return `${total}%`
                }
              }
            }
          }
        },
        labels,
        colors
    };

    return (
        <div id="chart">
            <ReactApexChart options={options} series={series} type="radialBar" height={350} />
        </div>
    );
}
 
export default RadialBarMultiple;